module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-btn', _vm._b({
    staticClass: "loader-button",
    style: (_vm.$slots.default || 'justify-content: center;'),
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.$emit('click')
      }
    }
  }, 'b-btn', _vm.$attrs, false), [_vm._t("default"), _vm._v(" "), (_vm.loading) ? _c('loader', {
    staticClass: "loader-button-loader"
  }) : (_vm.iconName) ? _c('fa-icon', {
    attrs: {
      "icon": _vm.iconName
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20fe7e1d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/Input/LoaderButton.vue
// module id = 1286
// module chunks = 1